// register component with react habitat
import codeSplit from '@src/scripts/higher-order-components/codeSplit';

export default {
	PostSelector: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "PostSelector" */
				'./index'
			),
	} ),
};
